import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "bg-gray-900 p-4 rounded flex items-center" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "text-gray-200 text-sm" }

import { PropType } from 'vue'
import { NetworkMeta } from '@injectivelabs/sdk-ui-ts'


export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkCard',
  props: {
  hideIcon: Boolean,

  networkMeta: {
    type: Object as PropType<NetworkMeta>,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.hideIcon)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: __props.networkMeta.icon,
          alt: __props.networkMeta.text,
          class: "h-4 w-4 rounded-full mr-2"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.networkMeta.text), 1)
  ]))
}
}

})